















































































































































































































import { EditorialProject, Element, ElementStatusPhase, ElementType, Milestone, MilestoneDate, SearchMilestoneOptions } from '@/models'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { CV_VALUE_COUNTRY_ES } from '@/utils/constants'
import ApiClient from '@/services/api-client'
import { ActionTypes } from '@/store/action-types'
import { Utils } from '@/utils'

interface NumberMap {
  [index: number]: string;
}
interface BooleanMap {
  [index: number]: boolean;
}

@Component({})
export default class UpsertTracingProductionProjectModal extends Vue {
  @Prop({ required: true }) editorialProject: EditorialProject

  private stateAccordionType: BooleanMap = {}
  private stateUpdateMilestoneDate: BooleanMap = {}

  private elementTypeToAdd: ElementType | null = null
  private milestones: Milestone[] = []

  private phase: NumberMap = {}
  private percentagePhase: NumberMap = {}
  private deadlineDate: NumberMap = {}

  private phaseUpdate: NumberMap = {}
  private percentagePhaseUpdate: NumberMap = {}
  private deadlineDateUpdate: NumberMap = {}

  @Watch('editorialProject', { deep: true })
  onEditorialProjectChanged() {
    this.resetModal()
  }

  get elementsTypeToDefineMilestone() {
    const elementTypesDefineMilestone = this.elementTypes.filter((elementType: ElementType) => elementType.defineMilestone === true)
    const elementTypeUsed = this.milestonesElementType.map(milestone => milestone.elementTypeId)
    return elementTypesDefineMilestone.filter((elementType: ElementType) => !elementTypeUsed.includes(elementType.codeId))
  }

  get elementTypes(): ElementType[] {
    return this.$store.state.elementTypes
  }

  get milestonesElementType() {
    return this.milestones.filter(milestone => !milestone.elementId)
  }

  get elementStatusPhases(): ElementStatusPhase[] {
    const elementStatusPhases = this.$store.state.elementStatusPhases.filter((elementStatusPhase: ElementStatusPhase) =>
      elementStatusPhase.editorialProjectId === this.editorialProject.id &&
      elementStatusPhase.country === this.editorialProject.country)
    return elementStatusPhases
  }

  private async resetModal() {
    await this.loadElementTypes()
    await this.loadElementStatusPhases()
    await this.loadMilestone()
  }

  async loadElementTypes() {
    await this.$store.dispatch(ActionTypes.LOAD_ELEMENT_TYPES)
  }

  private async loadMilestone() {
    const searchOptions: SearchMilestoneOptions = {
      editorialProjectId: this.editorialProject.id,
      country: this.editorialProject.country,
      campaign: this.editorialProject.yearStart,
      limit: 100
    }
    const result = await ApiClient.searchMilestones(searchOptions)
    this.milestones = result.items

    // Complete milestone with phase
    for (const milestone of this.milestones) {
      if (milestone.milestoneDates) {
        for (const milestoneDate of milestone.milestoneDates) {
          const phase = this.elementStatusPhases.find(item => item.elementStatusPhaseId === milestoneDate.phase)
          milestoneDate.phaseObject = phase
        }
      }
    }
  }

  private async loadElementStatusPhases() {
    if (!this.editorialProject) {
      return
    }
    await this.$store.dispatch(ActionTypes.GET_ELEMENT_STATUS_PHASES, { editorialProjectId: this.editorialProject.id, country: this.editorialProject.country })
  }

  hideModal() {
    this.$bvModal.hide('upsertTracingProductionProjectModal')
  }

  private async addMilestoneFromElementType() {
    const milestone: Milestone = {
      milestoneId: 0,
      campaign: this.editorialProject.yearStart ? this.editorialProject.yearStart : new Date().getFullYear(),
      editorialProjectId: this.editorialProject.id ? this.editorialProject.id : '',
      country: this.editorialProject.country ? this.editorialProject.country : CV_VALUE_COUNTRY_ES,
      elementTypeId: (this.elementTypeToAdd && this.elementTypeToAdd.codeId) ? this.elementTypeToAdd.codeId : '',
      milestoneDates: []
    }

    try {
      const resultCreate = await ApiClient.createMilestone(milestone)
      milestone.milestoneId = resultCreate.milestoneId
      this.milestones.push(milestone)

      // Clear select
      this.elementTypeToAdd = null
    } catch (error) {
      console.log('Error create milestone', error)
    }
  }

  private async removeMilestone(milestone: Milestone) {
    try {
      ApiClient.deleteMilestone(milestone.milestoneId)
      const index = this.milestones.findIndex(item => item.milestoneId === milestone.milestoneId)
      this.milestones.splice(index, 1)
    } catch (error) {
      console.log('Error delete milestone', error)
    }
  }

  private async addMilestoneDate(milestone: Milestone) {
    if (!milestone || !milestone.milestoneDates) {
      return false
    }

    const milestoneDate: MilestoneDate = {
      milestoneDateId: 0,
      milestoneId: milestone.milestoneId,
      phase: this.phase[milestone.milestoneId],
      percentagePhase: parseInt(this.percentagePhase[milestone.milestoneId]),
      deadlineDate: this.deadlineDate[milestone.milestoneId]
    }

    try {
      const resultCreate = await ApiClient.createMilestoneDate(milestoneDate)

      const phase = this.elementStatusPhases.find(item => item.elementStatusPhaseId === milestoneDate.phase)
      resultCreate.phaseObject = phase
      milestone.milestoneDates.push(resultCreate)

      this.clearFormMilestoneDate(milestone)
    } catch (error) {
      console.log('Error create milestone date', error)
    }
  }

  private async removeMilestoneDate(milestone: Milestone, milestoneDate: MilestoneDate, index: number) {
    if (milestone && milestone.milestoneDates && index >= 0 && index < milestone.milestoneDates.length) {
      try {
        ApiClient.deleteMilestoneDate(milestoneDate.milestoneDateId)
        milestone.milestoneDates.splice(index, 1)
      } catch (error) {
        console.log('Error delete milestone date', error)
      }
    }
  }

  private async editMilestoneDate(milestoneDate: MilestoneDate) {
    Vue.set(this.stateUpdateMilestoneDate, milestoneDate.milestoneDateId, true)

    Vue.set(this.phaseUpdate, milestoneDate.milestoneDateId, milestoneDate.phase)
    Vue.set(this.deadlineDateUpdate, milestoneDate.milestoneDateId, milestoneDate.deadlineDate)
    Vue.set(this.percentagePhaseUpdate, milestoneDate.milestoneDateId, milestoneDate.percentagePhase)
  }

  private async updateMilestoneDate(milestoneDate: MilestoneDate) {
    milestoneDate.phase = this.phaseUpdate[milestoneDate.milestoneDateId]
    milestoneDate.deadlineDate = this.deadlineDateUpdate[milestoneDate.milestoneDateId]
    milestoneDate.percentagePhase = parseInt(this.percentagePhaseUpdate[milestoneDate.milestoneDateId])

    const milestoneDateCopy = JSON.parse(JSON.stringify(milestoneDate))
    delete milestoneDateCopy.phaseObject
    try {
      await ApiClient.updateMilestoneDate(milestoneDateCopy)

      const phase = this.elementStatusPhases.find(item => item.elementStatusPhaseId === milestoneDate.phase)
      milestoneDate.phaseObject = phase
      this.cancelUpdateMilestoneDate(milestoneDate)
    } catch (error) {
      console.log('Error create milestone', error)
    }
  }

  private async cancelUpdateMilestoneDate(milestoneDate: MilestoneDate) {
    Vue.set(this.stateUpdateMilestoneDate, milestoneDate.milestoneDateId, false)

    Vue.set(this.phaseUpdate, milestoneDate.milestoneDateId, null)
    Vue.set(this.deadlineDateUpdate, milestoneDate.milestoneDateId, null)
    Vue.set(this.percentagePhaseUpdate, milestoneDate.milestoneDateId, null)
  }

  private clearFormMilestoneDate(milestone: Milestone) {
    Vue.delete(this.phase, milestone.milestoneId)
    Vue.delete(this.percentagePhase, milestone.milestoneId)
    Vue.delete(this.deadlineDate, milestone.milestoneId)
  }

  private getElementTypeName(codeId: string) {
    return Utils.findElementTypeName(codeId, this.$store.getters.elementTypes)
  }

  private orderMilestoneDate(milestoneDates: MilestoneDate[]) {
    return milestoneDates ? milestoneDates.slice().sort((a, b) => {
      const dateA = new Date(a.deadlineDate).getTime()
      const dateB = new Date(b.deadlineDate).getTime()
      return dateA - dateB
    }) : []
  }
}
